import { addCustomEventDataLayer } from "./utils";
function createFormDataLayer( formElement, eventName, formName, formPath, error ) {
    addCustomEventDataLayer( formElement, eventName, {
        'form': {
            'name': formName,
            'formID': formPath,
            'source': 'AEM',
            'category': formName,
            ...error
        }
    });
}
function formLoadListener( formElement, guideBridge, formName, formPath ) {
    guideBridge.on( "bridgeInitializeComplete", function () {
        createFormDataLayer( formElement, 'form_view', formName, formPath );
    });
}
function formValidationListener( formElement, guideBridge, formName, formPath ) {
    guideBridge.on( "validationComplete", function ( event, payload ) {
        if ( payload.prevText || !payload.newText.length ) {
            createFormDataLayer( formElement, 'form_submit', formName, formPath );
        } else {
            const error = {
                'errors': [ {
                    'name': guideBridge.resolveNode( payload.newText[ 0 ].som ).title,
                    'value': payload.newText[ 0 ].errorText
                } ]
            };
            createFormDataLayer( formElement, 'form_validation_error', formName, formPath, error );
        }
    });
}
function initAEMForm( guideBridge ) {
    const compElement = document.querySelector( ".aemform" );
    if( !compElement ) {
        return;
    }
    const formDocument = compElement.querySelector( "#aemFormFrame" ).contentDocument;
    const formName = formDocument.title.toLowerCase();
    const formPath = formDocument.querySelector('.aemformcontainer').dataset.formPagePath;
    formLoadListener( compElement, guideBridge, formName, formPath );
    formValidationListener( compElement, guideBridge, formName, formPath );
    window.removeEventListener( "bridgeInitializeStart", initAEMForm );
}
function bridgeInitializeListener( event ) {
    initAEMForm( event.detail.guideBridge );
}
if ( window.guideBridge ) {
    initAEMForm( window.guideBridge );
} else {
    window.addEventListener( "bridgeInitializeStart", bridgeInitializeListener );
}